export default "__VITE_ASSET__cfe35e09__"